import React from "react";
import "./style.scss";
import cn from "classnames";

const Checkbox = ({
  id,
  id2,
  checked,
  onChange,
  errorCheckbox,
  type = "checkbox",
  value,
  name,
}) => {
  return (
    <>
      <input
        className={"styled-checkbox"}
        type={type}
        onChange={onChange ? (e) => onChange(e) : console.log("Change inner")}
        checked={checked}
        id={id}
        name={name}
        value={value}
      />
      <div
        id={id2}
        className={cn("styled-checkbox--indicator", {
          errorCheckbox: errorCheckbox,
        })}
      />
    </>
  );
};

export default Checkbox;
